module.exports = __webpack_public_path__ + "static/media/material_bg.81470bc1.svg";